"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RequireAuth_1 = __importDefault(require("@Components/RequireAuth"));
const RightsholderLayout_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderLayout"));
const react_1 = __importDefault(require("react"));
require("./index.scss");
const creatework_1 = __importDefault(require("@App/routes/rightsholder/creatework"));
const root_1 = __importDefault(require("@App/routes/rightsholder/root"));
const route_1 = require("@App/navigation/route");
const createRightsholderRoutes = () => {
    const createWorkRoutes = (0, creatework_1.default)();
    const rightsholderRootRoutes = (0, root_1.default)();
    return {
        path: route_1.RIGHTSHOLDER_ROUTE_WITH_ID,
        element: (react_1.default.createElement(RequireAuth_1.default, null,
            react_1.default.createElement(RightsholderLayout_1.default, null))),
        children: [createWorkRoutes, rightsholderRootRoutes],
    };
};
exports.default = createRightsholderRoutes;
